import React from 'react'

export default function TextError({ validate = null }) {
    return (
        <span style={{ color: '#ff5b57', fontSize: '.6875rem' }} hidden={!validate}>{validate}</span>
    )
}
